import { Badge } from "@/components/ui/badge";
import type { NormalizedEvent } from "@/services/types/agent-gateway";
import { Wrench } from "lucide-react";
import {
  formatEventAuthor,
  formatEventStatus,
  formatEventTime,
} from "./event-utils";

type ToolEvent = Extract<
  NormalizedEvent,
  { type: "tool_started" | "tool_completed" }
>;

export function ToolActivity({ event }: { event: ToolEvent }) {
  return (
    <details className="group rounded-lg border border-slate-200 bg-white">
      <summary className="flex min-w-0 cursor-pointer list-none items-center gap-3 px-4 py-3 outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50">
        <Wrench aria-hidden="true" className="size-4 shrink-0 text-slate-500" />
        <span className="min-w-0 flex-1 font-medium text-sm [overflow-wrap:anywhere]">
          {event.content.label}
        </span>
        <Badge className="rounded-full" variant="outline">
          {formatEventStatus(event.content.status)}
        </Badge>
      </summary>

      <dl className="grid gap-3 border-slate-100 border-t px-4 py-3 text-sm sm:grid-cols-3">
        <div>
          <dt className="text-slate-400">Agent</dt>
          <dd>{formatEventAuthor(event.author)}</dd>
        </div>
        <div className="min-w-0">
          <dt className="text-slate-400">Tool</dt>
          <dd className="font-mono text-xs [overflow-wrap:anywhere]">
            {event.content.tool}
          </dd>
        </div>
        <div>
          <dt className="text-slate-400">Time</dt>
          <dd>{formatEventTime(event.created_at)}</dd>
        </div>
      </dl>
    </details>
  );
}
